import { routes } from "../utlis/staff/routes.utlis";
import { StaffLayout } from "../layouts/staff/App.js";
import Dashboard from "../views/staff/dashboard/Page.js";
import Jobs from "../views/staff/jobs/Page.js";
import LockedJob from "../views/staff/jobs/LockedJob.js";
import JobDetails from "../views/staff/jobs/Details.js";
import Message from "../views/staff/message/Page.js";
import CareNetwork from "../views/staff/care-network/Page.js";
import CareNetworkDetails from "../views/staff/care-network/Details.js";
import Calendar from "../views/staff/calendar/Page.js";
import Newsletter from "../views/staff/newsletter/Page.js";
import Advertisement from "../views/staff/advertisement/Page.js";
import AdvertisementDetails from "../views/staff/advertisement/Details.js";
import Profile from "../views/staff/profile/Page.js";
import NetworkDirectory from "../views/staff/network-directory/Page.js";
import SubscriptionPlan from "../views/staff/subscription-plan/Page.js";
import AppliedJob from "../views/staff/care-network/AppliedJob.js";
import PostedAds from "../views/staff/advertisement/PostedAds.js";
import AboutUs from "../views/staff/more/AboutUs.js";
import PrivacyPolicy from "../views/staff/more/PrivacyPolicy.js";
import TermCondition from "../views/staff/more/TermCondition.js";
import ProviderDetail from "../views/staff/network-directory/ProviderDetail.js";
import TransactionHistory from "../views/staff/transaction/Page.js";
import Contact from "../views/staff/more/Contact.js";
import UserChat from "../views/staff/message/UserChat.js";
import Rating from "../views/staff/more/Rating.js";
import ExpensesDashboard from "../views/staff/expenses/Dashboard.js";
import ExpensesCreate from "../views/staff/expenses/Create.js";
import ExpensesEdit from "../views/staff/expenses/Edit.js";
import List from "../views/staff/expenses/List.js";
import BudgetList from "../views/staff/expenses/BudgetList.js";
import CommunityDashboard from "../views/staff/community/Dashboard.js";
import Following from "../views/staff/community/Following.js";
import MyCommunity from "../views/staff/community/MyCommunity.js";
import CommunityDetail from "../views/staff/community/Details.js";
import PostDetails from "../views/staff/community/PostDetails.js";
import SuggestedList from "../views/staff/community/SuggestedList.js";
import ShareProfile from "../views/staff/community/ShareProfile.js";
import CouponList from "../views/staff/loyalty/CouponList.js";

var StaffRoutes = [
    {
        path: routes.dashboard,
        layout: StaffLayout,
        component: Dashboard
    },
    {
        path: routes.message,
        layout: StaffLayout,
        component: Message
    },
    {
        path: routes.staffMessage,
        layout: StaffLayout,
        component: UserChat
    },
    {
        path: routes.myJobs,
        layout: StaffLayout,
        component: Jobs
    },
    {
        path: routes.lockedJobs,
        layout: StaffLayout,
        component: LockedJob
    },
    {
        path: routes.jobDetails,
        layout: StaffLayout,
        component: JobDetails
    },
    {
        path: routes.careNetwork,
        layout: StaffLayout,
        component: CareNetwork
    },
    {
        path: routes.careNetworkDetails,
        layout: StaffLayout,
        component: CareNetworkDetails
    },
    {
        path: routes.appliedJob,
        layout: StaffLayout,
        component: AppliedJob
    },
    {
        path: routes.advertisement,
        layout: StaffLayout,
        component: Advertisement
    },
    {
        path: routes.postedAdvertisement,
        layout: StaffLayout,
        component: PostedAds
    },
    {
        path: routes.advertisementDetails,
        layout: StaffLayout,
        component: AdvertisementDetails
    },
    {
        path: routes.networkDirectory,
        layout: StaffLayout,
        component: NetworkDirectory
    },
    {
        path: routes.userDetail,
        layout: StaffLayout,
        component: ProviderDetail
    },
    {
        path: routes.calendar,
        layout: StaffLayout,
        component: Calendar
    },
    {
        path: routes.newsletter,
        layout: StaffLayout,
        component: Newsletter
    },
    {
        path: routes.profile,
        layout: StaffLayout,
        component: Profile
    },
    {
        path: routes.transactionList,
        layout: StaffLayout,
        component: TransactionHistory
    },
    {
        path: routes.subscriptionPlan,
        layout: StaffLayout,
        component: SubscriptionPlan
    },
    {
        path: routes.aboutUs,
        layout: StaffLayout,
        component: AboutUs
    },
    {
        path: routes.privacyPolicy,
        layout: StaffLayout,
        component: PrivacyPolicy
    },
    {
        path: routes.termsCondition,
        layout: StaffLayout,
        component: TermCondition
    },
    {
        path: routes.contactUs,
        layout: StaffLayout,
        component: Contact
    },
    {
        path: routes.reviewList,
        layout: StaffLayout,
        component: Rating
    },
    {
        path: routes.expenseDashboard,
        layout: StaffLayout,
        component: ExpensesDashboard
    },
    {
        path: routes.expenseCreate,
        layout: StaffLayout,
        component: ExpensesCreate
    },
    {
        path: routes.expenseEdit,
        layout: StaffLayout,
        component: ExpensesEdit
    },
    {
        path: routes.expenseList,
        layout: StaffLayout,
        component: List
    },
    {
        path: routes.budgetList,
        layout: StaffLayout,
        component: BudgetList
    },
    {
        path: routes.communityDashboard,
        layout: StaffLayout,
        component: CommunityDashboard
    },
    {
        path: routes.communitySuggested,
        layout: StaffLayout,
        component: SuggestedList
    },
    {
        path: routes.communityFollowing,
        layout: StaffLayout,
        component: Following
    },
    {
        path: routes.communityList,
        layout: StaffLayout,
        component: MyCommunity
    },
    {
        path: routes.communityInfo,
        layout: StaffLayout,
        component: CommunityDetail
    },
    {
        path: routes.communityPostInfo,
        layout: StaffLayout,
        component: PostDetails
    },
    {
        path: routes.communityShareProfile,
        layout: StaffLayout,
        component: ShareProfile
    },
    {
        path: routes.careLoyalty,
        layout: StaffLayout,
        component: CouponList
    },
];

export default StaffRoutes;